<template>
  <div class="editPage" v-loading="subLoading">
  <!--    地图 start-->
  <section class="mapBox">
    <MapForm ref="mapForm" @centerMarker="centerMarker" @draw="draw"></MapForm>

  </section>
  <!--    地图 end-->

  <!--    表单 start-->
  <section class="editBox">
    <BaseForm  ref="baseForm" @fenceShape="fenceShape"></BaseForm>
    <div class="subBtnBox">
      <el-button class="btn cancelBtn" @click="cancel">取消
      </el-button>
      <el-button class="btn" type="primary" @click="sub">保存
      </el-button>
    </div>

  </section>
  <!--    表单 end-->

  </div>
</template>

<script>
import pageDataMixin from '@qx/mixin/pageData';
import BaseForm from './baseForm';
import MapForm from './mapForm';
import {querySysRegionCodeTree, queryFenceDetail, saveOrUpdateFence} from 'api/operate';
import {getEnumList} from 'api';
import {getDepartmentAllList} from 'api/index';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    MapForm,
  },
  data () {
    return {
      pageUrl: '/manage/operate/track/electronicFence/edit',
      formComponents: ['baseForm'],
      editParams: {
        fenceId: this.$route.query.fenceId,
      },
      subLoading: false,
    };
  },
  computed: {
    detailParams () {
      return {
        fenceId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: queryFenceDetail,
    editApi: saveOrUpdateFence,
    handleParams (params) {
      if (params.fenceShape === '1') {
        let formData = {};
        const pts = this.$refs.baseForm.pts;
        formData.lng = String(pts.lng);
        formData.lat = String(pts.lat);
        formData.radius = this.$refs.baseForm.baseForm.alarmRadius;
        formData.name = '圆形';
        params.circles = JSON.stringify([formData]);
        delete params.area;
      } else if (params.fenceShape === '2') {
        this.$refs.mapForm.polygonPath.map((item, index) => {
          item.pIndex = index;
          item.lat = String(item.lat);
          item.lng = String(item.lng);
        });
        let formData = {};
        formData.name = '多边形';
        if (this.$refs.mapForm.polygonPath && this.$refs.mapForm.polygonPath.length === 0) {
          this.$message({
            type: 'error',
            message: '请绘制多边形区域！',
          });
          return;
        }
        formData.points = JSON.stringify(this.$refs.mapForm.polygonPath);
        params.polygons = JSON.stringify([formData]);
        delete params.alarmRadius;
        delete params.area;
      } else if (params.fenceShape === '3') {
        let formData = {};
        formData.name = '区域围栏';
        formData.countryName = params.countryName;
        formData.countrygb = params.area;
        params.stations = JSON.stringify([formData]);
        delete params.alarmRadius;
      }
      console.log('提交参数', params);
    },
    cancel () {
      this.close();
    },
    fenceShape (val, data, point) {
      this.$refs.mapForm.fenceShape(val, data, point);
    },
    centerMarker (data) {
      this.$refs.baseForm.centerMarker(data);
    },
    draw (isDraw) {
      this.$refs.baseForm.draw(isDraw);
    },
  },
  async mounted () {
    if (this.$refs.baseForm) {
      const enumsList = await getEnumList({
        codeType: 'FENCE_SHAPE',
      });
      const orgIdOptions = await getDepartmentAllList();
      const areaOptions = await querySysRegionCodeTree();
      this.$refs.baseForm.setList([enumsList[0], orgIdOptions, areaOptions]);
    }
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.editPage{
  //position: relative;
  padding-bottom: 0;
  display: flex;


  //地图
  .mapBox{
    width:75%;
    height: 821px;

    //.map{
    //  width: 100%;
    //  height: 100%;
    //}
  }

  .editBox{
    width: 25%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding:20px 0px 20px 20px;

    .subBtnBox{
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        width: 160px;
        height: 40px;
      }
      .cancelBtn {
        margin-right: 24px;
      }
    }


    //.subBtnBox{
    //  //width: 0;
    //  //background: #fff;
    //  bottom: 38px;
    //  right: 22px;
    //  background: rgba(255, 255, 255, 0);
    //}
  }

}


</style>
